
import { defineComponent, ref } from 'vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'

import Arrows from '@/components/Start/Arrows.vue'
import FacebookPosts from '@/components/Start/FacebookPosts.vue'
import Button from '@/components/Common/Button.vue'
import BackgroundImage from '@/components/Common/BackgroundImage.vue'

export default defineComponent({
    name: 'Start',
    components: {
        ScrollParallax,
        Arrows,
        Button,
        BackgroundImage,
        FacebookPosts,
    },
    setup() {
        const showArrows = ref(true)

        window.addEventListener('scroll', () => {
            const height = window.innerHeight
            const offsetOfHeight = window.pageYOffset / height

            if (offsetOfHeight > 0.4) {
                showArrows.value = false
            } else {
                showArrows.value = true
            }
        })

        return { showArrows }
    },
})
